import { createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store"
import { ListSow, MRSowStore } from "./sow.model"
import { setListSow, setListSowLoading } from "./sow.action"



export const initialState: MRSowStore = {
	loading: false,
	listSow: {
		totalRecord: 0,
		pageTotal: 0,
		pageSize: 0,
		data: []
	}
}

export const MRSowReducer = createReducer(
	initialState,
	on(setListSow, (state, actions) => ({ ...state, listSow: actions.payload })),
	on(setListSowLoading, (state, actions) => ({ ...state, loading: actions.payload }))
)

export const selectMRPWFunctionStore = createFeatureSelector<MRSowStore>('mr_pw_planning_and_function')

export const selectListSow = createSelector(
	selectMRPWFunctionStore,
	(state: MRSowStore) => state.listSow
)

export const selectLoadListSow = createSelector(
	selectMRPWFunctionStore,
	(state: MRSowStore) => state.loading
)
